<template>
  <v-text-field
    v-model="searchPhrase"
    class="searchbox-input"
    persistent-hint
    background-color="white"
    hide-details
    clearable
    :placeholder="searchPlaceholder"
    v-bind="props.shortTextField"
    prepend-inner-icon="mdi-magnify"
    @keyup="search"
    @click:clear="search"
  />
</template>

<script>
import { mapState } from 'vuex';
import debounce from 'lodash.debounce';
import props from '@/helpers/componentsProps';

export default {
  props: {
    searchPlaceholder: {
      type: String,
      default: 'Wyszukaj projektu',
    },
  },

  data() {
    return {
      searchPhrase: '',
      props,
    };
  },

  computed: {
    ...mapState('filters', [
      'selectedFilters',
    ]),
  },

  watch: {
    selectedFilters() {
      if (!this.selectedFilters.query) this.searchPhrase = '';
    },
  },

  created() {
    if (this.selectedFilters.query) this.searchPhrase = this.selectedFilters.query;
  },

  methods: {
    // eslint-disable-next-line func-names
    search: debounce(function () { this.$emit('search', this.searchPhrase); }, 500),
  },
};
</script>

<style lang="scss">
.searchbox-input {
  max-width:326px;
  margin-right:8px;
}
</style>
